// GENERATED FILE. Do not edit by hand. Produced by `bun run codegen` from
// x-flags.doRenderReactQueryQueryHook on POST /player/season-stats-get.

import { useQuery, type UseQueryOptions } from "@tanstack/react-query";
import type {
  typePlayerSeasonStatsGetBody,
  typePlayerSeasonStatsGetOutput200,
} from "../../sdk/player/postPlayerSeasonStatsGet";
import useCallSdk from "../../sdk-helpers/useCallSdk";

export function buildPlayerSeasonStatsGetQueryKey(
  payload: typePlayerSeasonStatsGetBody,
): string[] {
  const queryKeySegments: string[] = [];
  queryKeySegments.push(`playerId:${JSON.stringify(payload.playerId)}`);
  return [
    "post:player:playerSeasonStatsGet",
    "svc:sports-api",
    ...queryKeySegments,
  ];
}

type QueryOptions = Partial<
  UseQueryOptions<
    typePlayerSeasonStatsGetOutput200,
    unknown,
    typePlayerSeasonStatsGetOutput200,
    string[]
  >
> & {
  // Isolates two callers that query the same data for independent UI state
  // (e.g. a dropdown search vs a table both listing the same resource).
  queryKeyIdentifier?: string;
};

export default function usePlayerSeasonStatsGet(
  payload: typePlayerSeasonStatsGetBody,
  options?: QueryOptions,
) {
  // No staleTime default here on purpose. Freshness is the consuming app's
  // decision and belongs in its QueryClient, in one place: a default set on the
  // hook would silently beat it for every screen. Pass one per call to override.
  const resolvedOptions = options ?? {};

  let queryKey = buildPlayerSeasonStatsGetQueryKey(payload);
  if (resolvedOptions.queryKeyIdentifier) {
    queryKey = [...queryKey, resolvedOptions.queryKeyIdentifier];
  }

  const { callSdk } = useCallSdk();
  return useQuery({
    queryKey,
    queryFn: () => callSdk().postPlayerSeasonStatsGet(payload),
    ...resolvedOptions,
  });
}
